module.exports = __webpack_public_path__ + "static/gis_logo-442bfde8404537f6262c1af89068bb9e.png";